import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/admin/AuthContext";

export const ProtectedAdminRoute = ({ children }) => {
  const { user, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white/50 text-xs tracking-luxe uppercase">
        Authenticating…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedAdminRoute;
